import Link from '@/app/_adapters/next-link';
import {
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/app/_components/ui/sidebar';
import { LucideIcon } from 'lucide-react';

interface SidebarMenuSubItemLinkProps {
  title: string;
  href: string;
  icon: LucideIcon;
  pathname: string;
  isMobile: boolean;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
}

export function SidebarMenuSubItemLink({
  title,
  href,
  icon: Icon,
  pathname,
  isMobile,
  openMobile,
  setOpenMobile,
}: SidebarMenuSubItemLinkProps) {
  const active = pathname === href;

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton
        asChild
        isActive={active}
        className="hover:cursor-pointer py-2"
      >
        <Link
          href={href}
          onClick={() => {
            if (isMobile && openMobile) setOpenMobile(false);
          }}
        >
          <Icon className="h-4 w-4" />
          <span>{title}</span>
        </Link>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
}
